import { ref, computed } from "vue";
import { useRuntimeStore } from "@/store/runtime"
import { useHistoryStore } from "@/store/history"
import { useApi } from "@/service/api"
import { useNetworkStore } from "@/store/network";
import { defineStore } from "pinia";
import { useFilesStore } from "@/store/files"
import { useDataStore } from "@/store/data"
import { isProxy, toRaw } from 'vue';

// const dateToMinTime = (the_date) => {
//     the_date.setHours(0)
//     the_date.setMilliseconds(0)
//     the_date.setMinutes(0)
//     the_date.setSeconds(0)
//     return the_date
// }



const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const useTransferStore = defineStore("transferStore", () => {


    // const say = (text) => {
    //     // return
    //     console.log("🚀 " + text)
    // }

    const runtimeStore = useRuntimeStore();
    const historyStore = useHistoryStore();

    const api = useApi();
    const active = ref(false)
    const activeDuration = ref(0)
    const files_to_upload = ref([])
    const currentAction = ref("")
    const successfulRuns = ref([])
    const lastTry = ref({
        date: null,
        reason: "",
    })

    const actualRunlog = ref([])

    const uploadInteresting = ref(false)

    const graceTime = 10 * 1000
    const timeOutRunSeparation = 60 * 1000

    // let runIntervalAmount = 120 * 1000
    // runIntervalAmount = 5 * 1000

    let timeoutResetActiveDurationID = null

    const waitingReasons = ref("-")

    const increaseActiveDuration = () => {
        if (active.value)
            activeDuration.value += 1000
    }

    setInterval(increaseActiveDuration, 1000)

    const setActive = (value) => {
        
        clearTimeout(timeoutResetActiveDurationID)

        active.value = value

        if (!value) {
            timeoutResetActiveDurationID = setTimeout(() => {
                activeDuration.value = 0
            }, graceTime)
        }
    }


    const mayRun = function () {
        const networkStore = useNetworkStore();
        lastTry.value.reason = ""
        let reason = ""

        // checks

        if (!networkStore.online) {
            console.log("🚀 ", "🌐 no internet connection")
            reason = "connessione assente"
            // actualRunlog.value.push(reason)
            return {
                may: false,
                reason: reason
            }
        }

        if (!runtimeStore.session.settings.uploadEnabled) {
            console.log("🚀 ", "🌐 upload disabled by user")
            reason = "upload disabilitato dall'utente"
            // actualRunlog.value.push(reason)
            return {
                may: false,
                reason: reason
            }
        }


        // if ( ! runtimeStore.session.settings.uploadWithMobileConnection) {
        //     if (networkStore?.type === "wifi") {
        //         console.log("🚀 ", "🌐 no transmission under cellular connection")
        //         reason = "connessione cellulare, upload disabilitato"
        //         // actualRunlog.value.push(reason)
        //         return {
        //             may: false,
        //             reason: reason
        //         }
        //     }
        // }

        if (networkStore.trackerServerStatus === false) {
            console.log("🚀 ", "🌐 server unreachable, no upload")
            reason = "server down, upload disabilitato"
            // actualRunlog.value.push(reason)
            return {
                may: false,
                reason: reason
            }
        }

        return {
            may: true,
            reason: reason
        }

    }

    const run = async function () {

        console.log("🚀 ", "run - " + new Date(Date.now()).toLocaleString() )

        const filesStore = useFilesStore();
        const dataStore = useDataStore();


        if (!dataStore.userData) {
            console.log("🚀 ", "dataStore not available")
            return
        }


        //
        // F I L E S ////////////////////////////////////////////////////////
        //
        const getFilesToUpload = async () => {

            const UUIDsOfTodayFeaturesToIgnore = []  // that are uploaded or should be uploaded

            for (const [dayName, day] of Object.entries(dataStore.userData.tracker.days)) {
                if (dayName === dataStore.trackerTodayName) {
                    // console.log("🚀 ", "🔍 " + dayName + " excluding media of today features")
                    for (const feature of day.features) {
                        UUIDsOfTodayFeaturesToIgnore.push(feature.properties.uuid)
                    }
                }
            }

            const all_files = await filesStore.allFilesWithoutContent()
            // console.log("🚀 ", all_files )

            // debugger
            const files_to_upload = all_files
                .filter(file => !([200, 201, 409, 422].includes(file?.state)))   // not (uploaded or refused because already uploaded)
                .filter(file => file?.target_uuid !== undefined)      // only connected to a feature
                .filter((file) => {                                   // only connected as media under purpose property

                    if (file?.purpose === undefined) {
                        // upload all files created before 2024-08-31
                        // purpose value doesn't matters
                        if (file?.created_at < 1735689600000) { return true }
                        return false
                    }
                    if (file?.purpose === "media") { return true }
                    return false
                })
                .filter((file) => {                                     // not connected to today features
                    const considering = !UUIDsOfTodayFeaturesToIgnore.includes(file?.target_uuid)
                    // if (!considering) { console.log("🚀 ", "🔍 excluding media of today features", file?.target_uuid) }
                    return considering
                })

            console.log("🚀 ", "files to upload", files_to_upload)
            return files_to_upload
        }

        const uploadAllFiles = async () => {

            actualRunlog.value.push("* * * uploadAllFiles * * *")

            files_to_upload.value = await getFilesToUpload()

            actualRunlog.value.push("files: " + files_to_upload.value.length)

            if (files_to_upload.value.length === 0) {
                console.log("🚀 ", "no files to upload")
                actualRunlog.value.push("no files to upload")
                return true
            }



            for (const file of files_to_upload.value) {
                uploadInteresting.value = true
                actualRunlog.value.push("upload status set true 1")

                action = "file upload " + file?.id + " -  " + file?.name.slice(0, 10)

                const completefile = await filesStore.get(file.id)


                await sleep(1000)

                const response = await api.tracker.uploadFile(completefile)

                console.log("🚀 response for file upload")
                console.log(response)

                if (response?.ok) {
                    const data = await response.json();
                    if (data.success === true) {

                        console.log("🚀 ", "🟢 upload success", data);
                        await filesStore.updatedSomeValues(file.id,
                            {
                                state: 201
                            })

                        historyStore.pushInUserHistory({
                            uuid: undefined,
                            timestamp: file?.created_at,
                            coords: undefined,
                            label: file?.name,
                            type: file?.mimetype,
                        })


                        actualRunlog.value.push("okkkk" + " " + action)

                        continue
                    }
                }
                

                if (response?.status === 409) {

                    // "message": "duplicate key value violates unique constraint \"segnalazioni_media_timestamp_1f66f45eaf0a0081_uniq\"\nDETAIL:  Key (\"timestamp\", segnalatore_id)=(2025-07-15 15:40:16.458+00, 77) already exists.\n",

                    const data = await response.json();
                    if (data?.codename ===  "duplicate_key_violates_unique_constraint") {

                        console.log("🚀 ", "🔵 already uploaded", data);
                        await filesStore.updatedSomeValues(file.id,
                            {
                                state: 409
                            })
                        continue
                    }
                }


                // questo dovrebbe salvare qualsiasi status (ovvero no 201, no 409) di errore, così da non ritentare ad uploadare file che danno sempre lo stesso errore (esempio 422 per file troppo grandi)
                console.error("❌ upload error", response);
                actualRunlog.value.push("❌ " + String(response?.status) + " " + action)

                await filesStore.updatedSomeValues(file.id,
                    {
                        state: response?.status
                    })

            }


            console.log("🚀 ", "files to upload, CHECK AGAIN", files_to_upload.value)
            files_to_upload.value = await getFilesToUpload()
            if (files_to_upload.value.length > 0) {
                console.log("🚀 ", "cannot upload features, media are not completely uploaded")
                actualRunlog.value.push("= = non completamente caricati")
                return false
            }

            return true
        }

        //
        // F E A T U R E S ////////////////////////////////////////////////////////
        //

        const sendAllFeatures = async () => {

            console.log("🚀 ", "features to upload", dataStore.featuresToBeTransferred)
            actualRunlog.value.push("* * * segnalazioni * * *")

            // debugger


            for (const [dayName, day] of Object.entries(dataStore.userData.tracker.days)) {

                if (dayName === dataStore.trackerTodayName) {
                    console.log("🚀 ", "skipping features layer" + dayName + "(today 🟢)")
                    continue
                }

                if (day.state === 201) {
                    console.log("🚀 ", "skipping features layer " + dayName + " (201 🟢)")
                    continue
                }

                console.log("🚀 ", "features layer " + dayName + " to be transferred")
                action = "features layer to be transferred: " + dayName
                actualRunlog.value.push(action)

                for (const feature of day.features) {


                    if (feature.properties?.state === 201) {
                        // console.log("🚀 ", "skipping feature (201 🟢)", feature)
                        continue
                    }
                    if (feature.properties?.state === 409) {
                        console.log("🚀 ", "skipping feature (409 🔵)", feature)
                        continue
                    }
                    if (feature.properties?.state === 422) {
                        console.log("🚀 ", "skipping feature (422 🟡)", feature)
                        continue
                    }

                    action = "sending feature"
                    uploadInteresting.value = true
                    actualRunlog.value.push("upload status set true 2")



                    const rawFeature = isProxy(feature) ? toRaw(feature) : feature

                    console.log("🚀 ", "sending feature ", feature, rawFeature)


                    const response = await api.tracker.uploadFeature(rawFeature)
                        .catch(error => {
                            console.error('There was a problem with the uploadFeature operation:', error)
                            actualRunlog.value.push(" - ❌ " + String(response.status) + " " + action + " " + rawFeature?.properties?.uuid)

                        });


                    if (response?.ok || response?.status === 409) {

                        const data = await response.json();

                        if (response.status === 409) {
                            console.log("🚀 ", "🔵 already uploaded", data);
                            actualRunlog.value.push(" - 🔵 " + action)

                            feature.properties.state = 409
                            dataStore.save()

                            console.log("🚀 ", feature)
                        }

                        if (data.success === true) {
                            console.log("🚀 ", "🟢 upload succes", data);
                            actualRunlog.value.push(" - 🟢 " + action)

                            feature.properties.state = 201
                            dataStore.save()

                            console.log("🚀 ", feature)

                            historyStore.pushInUserHistory({
                                uuid: feature.properties?.uuid,
                                timestamp: feature.properties?.timestamp,
                                coords: [
                                    feature.properties.lon,
                                    feature.properties.lat,
                                ],
                                label: feature.properties?.label,
                                type: feature.properties?.model,
                            })

                        }


                    } else {

                        console.log("🚀 ", "❌ upload error");
                        console.log("🚀 ", "💬 ▶️ ");
                        console.log("🚀 ", rawFeature);
                        console.log("🚀 ", "💬 ◀️");
                        console.log("🚀 ", response);
                        if (response) {
                            actualRunlog.value.push(" - ❌ " + String(response.status) + " " + action + " " + rawFeature?.properties?.uuid)
                            feature.properties.state = response.status
                            dataStore.save()
                        }
                    }
                }

                dataStore.checkNSetDayUploaded(day)
            }


        }

        //
        // J O U R N A L  ////////////////////////////////////////////////////////
        //

        const sendAllJournalDays = async () => {
            console.log("🚀 ", "sending journal days", dataStore.userData.tracker.journal)

            actualRunlog.value.push("* * * giornate diario * * *")
            // debugger

            const today = new Date()
            today.setHours(0, 0, 0, 0)
            

            for (let [day_name, the_day] of Object.entries(dataStore.userData.tracker.journal)) {

                if (typeof the_day === 'string' || the_day instanceof String) {
                    // fix old data implementation
                    dataStore.userData.tracker.journal[day_name] = { state: null, text: the_day }
                    the_day = dataStore.userData.tracker.journal[day_name]
                }

                action = "sending journal day " + day_name

                if (the_day?.state === 201) {
                    // console.log("🚀 ", "skipping journal day " + day_name + " (201 🟢)")
                    continue
                }
                if (the_day?.state === 409) {
                    console.log("🚀 ", "skipping journal day " + day_name + " (409 🔵)")
                    continue
                }

                const the_date = new Date(day_name)
                the_date.setHours(0, 0, 0, 0)
                const msInDay = 24 * 60 * 60 * 1000;
                const pastdiff = Math.floor((today - the_date) / msInDay)

                // console.log("🚀 ", "was in the past by ", pastdiff, "days")

                if (pastdiff <= 10) { continue }
                if (pastdiff < 0) {
                    console.log("🚀 ", "hacker!")
                    continue
                }

                // console.log("🚀 ", the_date)
                // console.log("🚀 ", the_day)

                uploadInteresting.value = true
                actualRunlog.value.push("upload status set true 3")


                const rawDay = isProxy(the_day) ? toRaw(the_day) : the_day

                const payload = {
                    date: the_date.toISOString(),
                    text: rawDay.text,
                }
                console.log("🚀 ", payload)

                const response = await api.tracker.uploadJournalDay(payload)
                    // .catch(error => {
                    //     console.error('There was a problem with the uploadJournalDay operation:', error)
                    //     actualRunlog.value.push("❌ " + String(response.status) + " " + action + " " + day)

                    // });

                if (response?.ok) {

                    const data = await response.json();

                    if (data.success === true) {
                        console.log("🚀 ", "🟢 upload succes", data);
                        the_day.state = 201
                        dataStore.save()

                        // feature.properties.state = 201

                        actualRunlog.value.push("= = 🟢")
                        actualRunlog.value.push("🟢 " + " " + action)

                        historyStore.pushInUserHistory({
                            uuid: null,
                            timestamp: new Date(the_date).valueOf(),
                            coords: null,
                            label: the_date,
                            type: "journal_day",
                        })
                    }

                } 
                else {

                    console.error("❌ upload error", response);
                    if (response) {
                        actualRunlog.value.push("❌ " + String(response.status) + " " + action)
                        
                        if ([201, 409, 422].includes(response.status)) {
                            the_day.state = response.status
                            dataStore.save()
                            actualRunlog.value.push("❌ saved" + the_day.state)
                        }
                    }
                }
            }
        }


        let action = ""

        const allFilesUploaded = await uploadAllFiles()


        if (allFilesUploaded) {
            await sendAllFeatures()
        }

        await sendAllJournalDays()

        if (uploadInteresting.value) {
            // successfulRuns.value.push({
            //     log: actualRunlog.value.join("\n"),
            //     date: new Date(lastTry.value.date)
            // })
            successfulRuns.value = [{
                log: actualRunlog.value.join("\n"),
                date: new Date(lastTry.value.date)
            }].concat(successfulRuns.value)
            successfulRuns.value = successfulRuns.value.slice(-10)
        }
        else {
            lastTry.value.reason = "upload non necessario"
        }

        uploadInteresting.value = false
    }



    const runOnce = async function () {

        setActive(true)

        lastTry.value.date = new Date(Date.now())

        const mayRunResult = mayRun()

        if (mayRunResult?.may === false) {
            console.log("🚀 ", "🪚 transfer cannot happen: " + mayRunResult?.reason)
            lastTry.value.reason = mayRunResult?.reason
        }
        else {
            actualRunlog.value = []
            actualRunlog.value.push("---------------------------------")
            actualRunlog.value.push(new Date().toLocaleTimeString() + " - start")
            await run()
            currentAction.value = ""
            actualRunlog.value.push(new Date().toLocaleTimeString() + " - end")
        }

        setActive(false)

        console.log("🚀 ", "next runOnce in " + timeOutRunSeparation / 1000 + " s")
        await (new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, timeOutRunSeparation)
        }))

    }



    const runEveryInterval = async function () {

        console.log("🚀 ", "transferStore - " + new Date(Date.now()).toLocaleString() )
        console.log("🚀 ", "runEveryInterval now is " )

        while (true) {
            await runOnce()
        }

    }



    const lastSuccessfulRun = computed(() => {
        if (successfulRuns.value.length > 0) {
            return successfulRuns.value[successfulRuns.value.length - 1]
        }
        return null
    })




    // activate here intervalled checks for uploads (runEveryInterval)
    setTimeout(() => {
        console.log("🚀 ", "kickOff transferStore")
        runEveryInterval()
    }, 2 * 1000)

    return {
        run,
        runOnce,
        runEveryInterval,
        active,
        files_to_upload,
        currentAction,
        // uploadGranted,
        waitingReasons,
        lastTry,
        lastSuccessfulRun,
        successfulRuns,
        uploadInteresting,
    }
})




